import { ColumnsType } from "antd/es/table";
import NameLink from "../../Template/NameLink";
import ActionColumnSettings from "./ActionColumnSettings";
import TemplateLink from "./TemplateLink";
import SortIcon from "../../SharedComponent/TableColumnComponent/SortIcon";

const OrganizationsTableColumn: ColumnsType<any> = [
  {
    title: "Organization Name ",
    key: "name",
    dataIndex: "name",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data, record) => (
      <NameLink
        name={data}
        record={record}
        type="organization"
        navigateTo={`/auth/organization/${record.idTenant}`}
      />
    ),
  },
  {
    title: "Available Templates ",
    key: "templates",
    dataIndex: "templates",
    sorter: true,
    sortIcon: (order) => {
      return <SortIcon order={order} />;
    },
    render: (data, record) => (
      <TemplateLink
        data={data}
        record={record}
      />
    ),
    width: 400,
  },
  {
    title: "Actions ",
    key: "actions",
    render: (data, record) => <ActionColumnSettings record={record} />,
    width: 130,
  },
];

//generic the data for the table

export default OrganizationsTableColumn;
